import PeriodicallyReportsPage from './PeriodicallyReportsPage';

export default PeriodicallyReportsPage;
